import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: null,
};

export const scrollSlice = createSlice({
	name: "scroll",
	initialState,
	reducers: {
		add_scroll: (state, action) => {
			state.value = action.payload;
		},
		remove_scroll: (state) => {
			state.value = null;
		},
	},
});

// Action creators are generated for each case reducer function
export const { add_scroll, remove_scroll } = scrollSlice.actions;

export default scrollSlice.reducer;
